import CopyAllIcon from "@mui/icons-material/CopyAllRounded";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import { getErrorMessage } from "../../api/axiosHelper";
import { useNotificationContext } from "../../contexts/NotificationContext";

interface Props {
  textToCopy: string;
  tooltipTitle?: string;
}

const CopyToBufferButton = ({ textToCopy, tooltipTitle }: Props) => {
  const { sendNotificationError } = useNotificationContext();

  const [copied, setCopied] = useState(false);

  const handleCopyClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
      sendNotificationError(`Failed to copy: ${getErrorMessage(error)}`);
      return;
    }

    setCopied(true);
  };

  const handleMouseLeave = () => setCopied(false);

  return (
    <Tooltip
      onMouseLeave={handleMouseLeave}
      title={copied ? "Copied!" : (tooltipTitle ?? "Click to copy")}
      placement="bottom-end"
    >
      <CopyAllIcon color="secondary" sx={{ cursor: "pointer" }} onClick={handleCopyClick} />
    </Tooltip>
  );
};

export default CopyToBufferButton;
